import { useEffect, useRef } from "react";

export default function Particles({ density = 70, className = "", speed = 1 }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let raf, w, h, parts;

    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
      parts = Array.from({ length: density }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.6 + 0.3,
        vx: (Math.random() - 0.5) * 0.18 * speed,
        vy: (Math.random() - 0.5) * 0.14 * speed,
        o: Math.random() * 0.5 + 0.12,
        tw: Math.random() * Math.PI * 2,
      }));
    };
    const draw = (animate) => {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        if (animate) {
          p.x += p.vx; p.y += p.vy; p.tw += 0.02;
          if (p.x < 0) p.x = w; if (p.x > w) p.x = 0;
          if (p.y < 0) p.y = h; if (p.y > h) p.y = 0;
        }
        const alpha = animate ? p.o * (0.6 + 0.4 * Math.sin(p.tw)) : p.o;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(185, 210, 237, ${alpha})`;
        ctx.fill();
      }
    };
    const loop = () => { draw(true); raf = requestAnimationFrame(loop); };
    resize();
    if (reduced) { draw(false); } else { loop(); }
    window.addEventListener("resize", resize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, [density]);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      className={`absolute inset-0 z-0 pointer-events-none opacity-40 ${className}`}
      data-testid="particles-bg"
    />
  );
}
